import Select from '../../../components/ui/Select';
import SearchInput from '../../../components/ui/SearchInput';
import {
    INVOICE_STATUS_FILTERS,
    type AdminInvoiceFilters,
} from '../../../domain/superadmin/invoiceFilters';

type Props = {
    filters: AdminInvoiceFilters;
    onChange: (patch: Partial<AdminInvoiceFilters>) => void;
    search: string;
    onSearchChange: (value: string) => void;
};

const ALL = { value: '', label: 'Todos' };

function withAll(
    options: { value: string; label: string }[]
): { value: string; label: string }[] {
    return [ALL, ...options];
}

export function InvoicesFilters({ filters, onChange, search, onSearchChange }: Props) {
    return (
        <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <SearchInput
                value={search}
                onChange={onSearchChange}
                placeholder="Buscar por empresa ou número..."
            />
            <Select
                label="Status"
                selectSize="sm"
                value={filters.status}
                options={withAll(INVOICE_STATUS_FILTERS)}
                onChange={(e) => onChange({ status: e.target.value })}
            />
        </div>
    );
}
